import { render } from "./ListClient.vue?vue&type=template&id=43592d5d&scoped=true"
import script from "./ListClient.vue?vue&type=script&lang=js"
export * from "./ListClient.vue?vue&type=script&lang=js"

import "./ListClient.vue?vue&type=style&index=0&id=43592d5d&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43592d5d"]])

export default __exports__